import { FC } from "react";
import MobileBottomDrawer from "src/Modules/Hotels/Components/MobileBottomDrawer/MobileBottomDrawer";
import HotelPaymentCard from "./HotelPaymentCard";
import { useTranslation } from "react-i18next";

interface Props {
  payment: {
    pointsRedeemed: string;
    cashPaid: string;
    taxes: string;
    total: string;
    processedOn: string;
  };
  isFetching?: boolean;
}

const HotelPaymentDrawer: FC<Props> = ({ payment, isFetching }) => {
  const { t } = useTranslation();
  return (
    <MobileBottomDrawer
      title={t("UserHistory.hotel.paymentDetails")}
      barContent={<span className="font-inter text-xl font-bold tracking-tight text-font-active">{payment.total}</span>}
      drawerContent={<HotelPaymentCard payment={payment} isFetching={isFetching} />}
    />
  );
};

export default HotelPaymentDrawer;
